package com.hyperether.goodjob.scenes.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.Icon
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.Dp
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.user
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import org.jetbrains.compose.resources.painterResource

@Composable
fun CircleWithInitial(name: String?, size: Dp = 32.toScaleDp(), modifier: Modifier = Modifier, fontSize: Int = 18) {
    val firstLetter = name?.firstOrNull()?.uppercaseChar()?.toString() ?: ""

    Box(
        contentAlignment = Alignment.Center,
        modifier = modifier
            .size(size)
            .clip(CircleShape) // Clip the background into a circle
            .background(BlueApp)
    ) {
        if (firstLetter.isNotEmpty()) {
            Text(
                text = firstLetter,
                color = Color.White, // Text color
                fontSize = fontSize.toFloat().toScaleSp(),
                textAlign = TextAlign.Center,
                style = TextStyle(
                    fontSize = fontSize.toFloat().toScaleSp(),
                    color = Color.White,
                    textAlign = TextAlign.Center
                )

            )
        } else {
            Icon(
                painter = painterResource(Res.drawable.user),
                contentDescription = null,
                tint = Color.White,
                modifier = Modifier.size(15.toScaleDp())
            )
        }
    }
}
